import styled from 'styled-components';

import palette from '@utils/theme/palette';

export const Container = styled.div`
  margin-left: auto;
  & .rc-tooltip-placement-bottomRight {
    margin-top: 100px;
  }
`;
export const TooltipTitle = styled.div`
  font-weight: 300;
  font-size: 12px;
  display: flex;
  width: 82px;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.palette.D500};
`;

export const TooltipContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
`;
export const TotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.NL20};
  border-radius: 4px;
  padding: 4px;
  gap: 8px;
`;
export const Wrapper = styled.div`
  height: auto;
  display: block;
  justify-content: space-between;
  padding-top: 0px;
`;
export const SpanWrapper = styled.div<{ colorRating?: boolean }>`
  border-radius: 4px;
  width: auto;
  height: 23px;
  padding: 4px;
  background-color: ${({ colorRating }) =>
    colorRating ? palette.darkGreenScore : palette.orange};
  display: flex;
  gap: 4px;
`;
export const ScoringLine = styled.div`
  min-height: 5px;
  width: 100px;
`;
export const WrapperTitle = styled.div`
  line-height: 23px;
  margin-right: 6px;
  cursor: context-menu;
  display: flex;
  gap: 5px;
`;
export const Note = styled.span`
  font-size: 12px;
  font-weight: 300;
`;

export const Percent = styled.span`
  font-size: 14px;
  font-weight: 300;
  color: ${({ theme }) => theme.palette.D500};
`;
export const PercentWrapper = styled.div`
  max-width: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
export const TotalPercent = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.D500};
`;
export const MainTitle = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.D500};
`;
export const Separate = styled.hr`
  display: block;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.palette.gray87};
  padding: 0;
`;
export const NoteWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.D500};
  gap: 4px;
`;

export const TitleProgressContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const ExpediaScoring = styled.div`
  display: flex;
`;
